import { render, staticRenderFns } from "./print-resi-domestic.vue?vue&type=template&id=2cdb074a&scoped=true&"
import script from "./print-resi-domestic.vue?vue&type=script&lang=js&"
export * from "./print-resi-domestic.vue?vue&type=script&lang=js&"
import style0 from "./print-resi-domestic.vue?vue&type=style&index=0&id=2cdb074a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdb074a",
  null
  
)

export default component.exports